export const HERO_TYPING_STEP_MS = 18;
export const HERO_TYPING_START_DELAY_MS = 240;
export const HERO_TYPING_CHUNK_SIZE = 4;
export const HERO_QUESTION_DELAY_MS = 360;
export const HERO_THINKING_DELAY_MS = 1320;
export const HERO_ANSWER_DELAY_MS = 2200;
export const HERO_ANSWER_HOLD_MS = 2600;
export const HERO_FADE_DURATION_MS = 520;
export const MAX_HERO_SCENARIOS = 4;
export const HERO_HEADLINE_PRIMARY = 'Your members expect answers.';
export const HERO_HEADLINE_EMPHASIS = 'Not navigation.';
export const THOUGHTFABRIC_WEBSITE_URL = 'https://thoughtfabric.com';
export const LIVE_DEMO_ORG_LABEL_OVERRIDES = {
  'american board of opticianry and national contact lens examiners': 'ABO-NCLE',
};
